import { IdDescricao } from './util/id-descricao';
import { FormaDePagamento } from './forma-de-pagamento.model';
import { DemonstrativoDeResultado } from './demonstrativo-de-resultado.model';
import { Conta } from './conta.model';
import { Cheque } from './cheque';

export class MovimentacaoFinanceira {
  Id: number;
  ContaId: number;
  Conta: Conta;
  CreditoDebito: string;
  UsuarioCriacaoId: number;
  DataCriacao: string;
  ParticipanteId: number;
  Documento: string;
  DataLancamento: string;
  DataCompetencia: string;
  Historico: string;
  Valor: number;
  FormaDePagamentoId: number;
  DemonstrativoDeResultadoId: number;
  DemonstrativoDeResultado: DemonstrativoDeResultado;
  ChequeId: number;
  ReceberId: number;
  PagarId: number;
  ProcessoId: number;
  UnidadeId: number;
  FormaDePagamento: FormaDePagamento;

  Cheque: Cheque;

  constructor() {
    this.Cheque = null;
    this.DataLancamento = new Date().toISOString().split('T')[0];
    this.DataCompetencia = new Date().toISOString().split('T')[0];
    this.DemonstrativoDeResultado = new DemonstrativoDeResultado();
  }

}
